import {utilHelper} from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = 'api/dishDrink'

export const dishDrinkService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
    translate,
    getOptions,
    getPrices,
    reorderItems,
    translateAllDishDrinkInMenu
};


//search
function search(offset, max, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

//show
function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', {})
}

//save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id, fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{})
}

function translate(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data, message:SUCCESSFUL_TRANSLATION_LABEL });
}

//search
function getOptions(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { data, showAlert:false })
}

//obtener los precios
function getPrices(data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/prices`, 'POST', { data, showAlert:false })
}

//reorder
function reorderItems(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/reorder`, 'POST', { data });
}

function translateAllDishDrinkInMenu(id, data){
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/menu/${id}`, 'POST', { data, message: SUCCESSFUL_TRANSLATION_LABEL });
}